import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({ name: 'lmsFieldReport' })
export class FieldReportPipe implements PipeTransform {
  constructor() {}

  transform(value: string, pipeInfo: any): string {
    if (value !== '' && pipeInfo && pipeInfo.type === 'CurrencyPipe') {
      const pipe = new CurrencyPipe(pipeInfo.attr);
      const pipeOpts: any = pipeInfo.pipeOpts;
      return pipe.transform(value, pipeOpts[0], pipeOpts[1]);
    }
    return value;
  }
}
